import { Link } from "react-router-dom";
import type { NewsArticle } from "@/mocks/news";
import { formatViews } from "@/utils/news";

interface Props {
  articles: NewsArticle[];
  title?: string;
}

export default function HotRanking({ articles, title = "今日热议榜" }: Props) {
  return (
    <div className="bg-background-50 border border-background-200 rounded-lg overflow-hidden h-full flex flex-col">
      <div className="flex items-center justify-between px-4 py-3.5 border-b border-background-200">
        <h3 className="font-heading text-base font-bold text-foreground-950 flex items-center gap-2">
          <i className="ri-fire-line text-primary-500" />
          {title}
        </h3>
        <span className="text-[11px] text-foreground-500">按阅读量排序</span>
      </div>
      <ul className="flex-1 flex flex-col">
        {articles.map((article, index) => (
          <li key={article.id} className="border-b border-background-200/70 last:border-0 flex-1">
            <Link
              to={`/detail/${article.id}`}
              className="group flex items-start gap-3 px-4 py-3 cursor-pointer hover:bg-background-100 transition-colors h-full"
            >
              <span
                className={`w-5 shrink-0 font-heading text-base font-bold leading-6 ${
                  index < 3 ? "text-primary-500" : "text-foreground-300"
                }`}
              >
                {String(index + 1).padStart(2, "0")}
              </span>
              <span className="min-w-0 flex-1">
                <span className="block text-[13px] md:text-sm leading-snug text-foreground-800 line-clamp-2 group-hover:text-primary-600 transition-colors">
                  {article.title}
                </span>
                <span className="block mt-1 text-[11px] text-foreground-500 flex items-center gap-1">
                  <i className="ri-eye-line" />
                  {formatViews(article.views)}
                </span>
              </span>
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
}